export interface GenericError {
    errorType: ErrorType;
    message: string;
}

export enum ErrorType {
    AuthFailed = 'AuthFailed',
    InvalidSubDomainOrgId = 'InvalidSubDomainOrgId'
}
